
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"d":"M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334zm.77-9.545v3.052a.77.77 0 11-1.54 0V5.122a.77.77 0 111.54 0zM8 9.785a.926.926 0 110 1.852.926.926 0 010-1.852z"}})])
          )
        }
      }
    